import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Guid, Utility } from './core/common';
import { PersianDate } from './core/persian-date';
import { environment } from 'src/environments/environment';
const Mustache = require('mustache');

export class Common {
  static async shortUrl(url: string) {
    return `${environment.app.shortener}/${await Utility.getHttpRequest(`${environment.app.shortener}/add?url=${encodeURIComponent(url)}`)}`;
  }
  static mustache(template: string, data: any): string {
    return Mustache.render(template, data);
  }


  static EditotConfig_User: AngularEditorConfig = {
    editable: true,
    sanitize: true,
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        // 'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        // 'justifyLeft',
        // 'justifyCenter',
        // 'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        // 'insertUnorderedList',
        // 'insertOrderedList',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  static EditotConfig_Operator: AngularEditorConfig = {
    editable: true,
    sanitize: true,
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        // 'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        // 'justifyLeft',
        // 'justifyCenter',
        // 'justifyRight',
        'justifyFull',
        // 'indent',
        // 'outdent',
        // 'insertUnorderedList',
        // 'insertOrderedList',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        // 'link',
        // 'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule'
        // 'removeFormat',
        // 'toggleEditorMode'
      ]
    ]
  };
}

export class SeekerJobComparerItem {
  constructor(public title: string, public seekerField: any, public jobField: any,
    public match: any = (seeker, job) => this.seeker(seeker) === this.job(job)) { }

  seeker(seeker: any) {
    if (!this.seekerField) return seeker;
    if (typeof (this.seekerField) === 'string') return seeker?.Seeker?.[this.seekerField];
    return this.seekerField(seeker);
  }
  job(job: any) {
    if (!this.jobField) return job;
    if (typeof (this.jobField) === 'string') return job?.[this.jobField];
    return this.jobField(job);
  }
}

export enum KarpashaProgressStatus {
  InProgress = 0,
  Rejected = 1,
  Muted = 2,
  Completed = 3
}

export class SeekerJobCriteria {
  IsInProgress = true;
  SeekerId?: string;
  JobId?: string;
  KarpashaId?: string;
}

export class SearchParams {
  qs?: boolean;
  q?: string;
  state?: string;
  city?: string;
  l?: string;
  jt?: string[] | string;
  cmp?: string[];
  code?: number;
  c?: string[];
  remote?: boolean | 'true' | 'false';
  noexp?: boolean | 'true' | 'false';
  mb?: boolean | 'true' | 'false';
  edu?: string[];
  g?: string;
  insurance?: boolean | 'true' | 'false';
  hasState?: boolean | 'true' | 'false';
  hasEmployer?: boolean | 'true' | 'false';
  promoted?: boolean | 'true' | 'false';
  update?: number;
  rank?: number;
  karpasha?: string;
  karpashaPaid?: boolean | 'true' | 'false';
  sal?: number;
  dist?: number;
  src?: string;
  _Url?: string;
  _searchTitle?: string;
  _mode?: string;
  _jobtitles?: string[];

  constructor(params?: Partial<SearchParams>) {
    Object.assign(this, params);
  }

  static getParams(params: SearchParams): any {
    return !!params ? Utility.removeEmpty({ l: Utility.locationSearch(params.state, params.city), q: params.q }) : {};
  }
  static getQueryParams(params: SearchParams, ...remove: string[]): any {
    var queryParams = Utility.clone(params) || {};
    delete queryParams.state;
    delete queryParams.city;
    delete queryParams.l;
    delete queryParams.q;
    delete queryParams.Location;
    for (var key of remove)
      delete queryParams[key];
    return Utility.sortProperties(Utility.removeEmpty(queryParams, true));
  }
  static parse(url: string): SearchParams {
    var q = url.match(/(;q=)(?:.*?)(?=;|$)/g);
    var l = url.match(/(;l=)(?:.*?)(?=;|$)/g);
    var lp = l?.length ? Utility.getLocation(decodeURIComponent(l[l.length - 1]?.replace(';l=', ''))) : null;
    return {
      q: q?.length ? decodeURIComponent(q[q.length - 1]?.replace(';q=', '')) : undefined,
      state: lp ? lp.State : undefined,
      city: lp ? lp.City : undefined
    };
  }
}

export class KarpashaAgreements {
  static karpashaService = 'karpasha-service';
  static agentRegisteration = 'agent-registeration'; //new karpasha signup
  static karbaladService = 'service-karbalad';
  static seekerContract = 'contract-seeker';
  static employerAgreement = 'agreement-employer';
  static SeekerJobStatement = 'statement-seeker-job';
}

export enum NotificationStatus {
  All = -1,
  Unknown = 0,
  Ready = 1,
  Sending = 2,
  Sent = 3,
  Failed = 4
}

export class SeekerJobPayment {
  _title?: string;
  Amount: number;
  SeekerJobPaymentStatus = SeekerJobPaymentStatus.Pending;
  PaymentDate?: Date;
  PaymentId?: string
  PayerType = SeekerJobPaymentPayerType.Seeker;
}

export enum SeekerJobPaymentStatus {
  Pending = 0,
  Paid = 1,
  Failed = 2
}
export enum SeekerJobPaymentPayerType {
  Seeker = 0,
  Employer = 1,
  Karyar = 2
}

export enum Kind {
  NotAppliable = -1,
  Unknown = 0,
  Resume = 1,
  Basic = 2,
  Call = 3,
  Website = 4
}

export enum JobPaymentType {
  Unknown = 0,
  Monthly = 1,
  Daily = 2,
  Hourly = 3,
  Commission = 4,
  Adaptive = 5,
  PerProject = 6,
  Weekly = 7,
  Yearly = 8
}


export enum JobStatus {
  All = -1,
  // Draft = 0,
  NotPaid = 1,
  Pending = 2,
  Rejected = 3,
  Started = 4,
  Paused = 5,
  Finished = 6,
  Archived = 7,
  Expired = -2,
}

export enum JobSortType {
  None = 0,
  RegisterTime = 1,
  Score = 2,
  UpdateTime = 3,
  ExpirationTime = 4,
  Budget = 5,
  UsedBudget = 6,
  RemainingBudget = 7,
  BoostNeededDesc = 8,
  BoostNeededAsc = 9,
  RegisterTimeAsc = 10,
  StartTime = 12
}

export enum SourceType {
  Unknown = 0,
  Website = 1,
  Telegram = 2,
  Instagram = 3,
  Agent = 4,
  Karpishe = 5,
  Special = 6
}

export enum LocationLevel {
  Globe = 0,
  State = 1,
  City = 2
}

export enum ModelType {
  Unknown = 0,
  Job = 1,
  Resume = 2,
  User = 3
}

export enum ResourceStatus {
  Unknown = -1,
  Pending = 0,
  Published = 1,
  Rejected = 2,
  Paused = 3,
  Finished = 4,
  Archived = 5
}

export enum PaymentStatus {
  Link = -1,
  Pending = 0,
  Failed = 1,
  Completed = 2,
  Settled = 3
}

export enum NotificationType {
  None = 0,
  OperatorJobPending = 1,
  EmployerJobChangeStatus = 2,
  EmployerJobExpiring = 3,
  EmployerJobExpired = 4,
  EmployerJobApplied = 5,
  EmployerJobDigest = 6
}

export class BuyResumePackage {
  static PerMonthPrices = [
    { month: 1, price: 30000, },
    { month: 3, price: 20000, },
    { month: 6, price: 10000, },
    { month: 99, price: 5000, },
  ];
  static Price(date: Date) {
    var month = PersianDate.diff('MONTH', date);
    return BuyResumePackage.PerMonthPrices.find(_ => _.month > month)?.price;
  }
}
export class VanguardPackage {
  constructor(public Title: string, public Css: string, public Id: number, public Months: number, public Days: number,
    public Price: number, public Bonus?: string[], public Best?: boolean, public UIPrice?: number) { }
  _OriginalPrice?: number;
  // _PerMonth?: number;
  _Percent?: number;
}

export class JobCriteria {
  static fromParams(params: SearchParams, extraOptions?: any): JobCriteria {
    if (!params) params = {};
    let jtypes = typeof (params.jt) == 'string' ? params.jt?.split(',') : params.jt;
    let edu = typeof (params.edu) == 'string' ? (<string>params.edu)?.split(',') : params.edu;
    let remote = params.remote;
    if (jtypes?.find(_ => Utility.remoteJobTypes.includes(_))) {
      remote = 'true';
      jtypes = jtypes.filter(_ => !Utility.remoteJobTypes.includes(_));
    }
    return Object.assign({
      Keyword: params.q || undefined,
      State: Utility.getLocation(params.l).State || params.state || undefined,
      City: Utility.getLocation(params.l).City || params.city || undefined,
      UseQueryString: params.qs,
      Campaigns: params.cmp ? [params.cmp] : undefined,
      Code: params.code || undefined,
      Salary: params.sal || undefined,
      JobTypes: jtypes || undefined,
      IsRemote: (remote == 'true' || remote == true) ? true : ((remote == 'false' || remote == false) ? false : undefined),
      NoExperience: (params.noexp == 'true' || params.noexp == true) ? true : ((params.noexp == 'false' || params.noexp == false) ? false : undefined),
      HasMilitaryBonus: (params.mb == 'true' || params.mb == true) ? true : ((params.mb == 'false' || params.mb == false) ? false : undefined),
      Educations: edu || undefined,
      Gender: params.g || undefined,
      HasInsurance: (params.insurance == 'true' || params.insurance == true) ? true : ((params.insurance == 'false' || params.insurance == false) ? false : undefined),
      HasState: (params.hasState == 'true' || params.hasState == true) ? true : ((params.hasState == 'false' || params.hasState == false) ? false : undefined),
      HasEmployer: (params.hasEmployer == 'true' || params.hasEmployer == true) ? true : ((params.hasEmployer == 'false' || params.hasEmployer == false) ? false : undefined),
      PromotedEmployer: (params.promoted == 'true' || params.promoted == true) ? true : ((params.promoted == 'false' || params.promoted == false) ? false : undefined),
      SourceName: params.src || undefined,
      KarpashaId: params.karpasha || undefined,
      EmployerRank: params.rank || undefined,
      NearbyDistance: params.dist || undefined,
      Sort: JobSortType.Score
    }, extraOptions || {});

  }

  Code?: number;
  EmployerId?: string;
  AgentId?: string;
  State?: string;
  City?: string;
  District?: string;
  Keyword?: string;
  Company?: string[];
  AllowSearchFallback?: boolean;
  AppendExpired?: boolean;
  IncludeQueries?: boolean;
  IncludeRelatedPages?: boolean;
  IncludeSuggestions?: boolean;
  IncludeTopics?: boolean;
  IncludeJobTitles?: boolean;
  IncludeAdvertise?: boolean;
  UseQueryString?: boolean;
  IsDeleted?: boolean;
  HasAbuseReport?: boolean;
  IsExpired?: boolean;
  TaggedJobtitleId?: string;
  IsPaid?: boolean;
  PackageKeys?: string[];
  Statuses?: JobStatus[];
  ExcludedStatuses?: JobStatus[];
  SourceType?: number;
  NearbyDistance?: number;
  SourceName?: string;
  Sort?: JobSortType;
  Campaigns?: string[];
  JobTypes?: string[];
  PaidJobsCount?: number;
  IsRemote?: boolean;
  NoExperience?: boolean;
  HasMilitaryBonus?: boolean;
  Educations?: string[];
  Gender?: string;
  HasInsurance?: boolean;
  HasState?: boolean;
  HasEmployer?: boolean;
  Salary?: number;
  IncludedIds?: string[];
  ExcludedIds?: string[];
}

export class SeekerJobMatchCriteria {
  JobId?: string;
  SeekerId?: string;
  ExcludedJobTitles?: string[];
  LastSearchedFrom?: Date;
  LeadStatuses?: string[];
  JobLeadStatuses?: string[];
  Location?: { State: string, City: string };
  MinScore?: number;
}

export enum PaymentProvider {
  NotSpecified = -1,
  PayIr = 1,
  Zarinpal = 2,
  Payping = 3,
  Manual = 4,
}

export class JobSearchCriteria {
  Queries?: string[];
  State?: string;
  City?: string;
  HasUserId?: boolean;
  Limit = 20;
}

export class MetadataCriteria {
  Types?: MetadataType[];
  Header?: string;
  Variations?: string[];
  IsVerified?: boolean;
  IsProcessed?: boolean;
}

export class DiscountCriteria {

}

export enum MetadataType {
  Skill = 0,
  WrongSkill = 1,
  JobTitle = 2,
  JobType = 3
}

export class JobClickCriteria {
  Types?: ClickType[];
  BoardIds?: string[];
  FromDate?: Date;
  EndDate?: Date;
  ToDate?: Date;
}

export class AnnotationCriteria {
  Keyword?: string;
  FromTime?: Date;
  ToTime?: Date;
  IsDeleted?: boolean = false;
}

export enum ClickType {
  View = 0,
  Contact = 1,
  Apply = 2
}

export class FavoriteCriteria {
  ItemIds?: string[];
  UserId?: string;
  Type?: ModelType;
  IsExpired?: boolean;
}

export class Favorite {
  ItemId?: string;
  Type?: ModelType;
  ExpirationTime?: Date;
  Item?: any;
}

export class PaymentCriteria {
  UserId?: string;
  Amount?: number[];
  Statuses?: PaymentStatus[];
  Provider?: PaymentProvider;
  CreateTime?: Date[];
  ItemId?: string;
  Keyword?: string;
}

export class UserCriteria {
  Keyword?: string;
  Roles?: string[];
  LastUpdateFrom?: Date;
  Employer?: any;
  Seeker?: any;
  Agent?: any;
  Karpasha?: any;
  HasUsername?: boolean;
  Sort?: UserSortType;
  UseQueryString?: boolean;
  ShowDebug?: boolean;
  ShowHighlights?: boolean;
  ShowScores?: boolean;
  Username?: string;

  static fromParams(params: any, type: 'seeker' | 'employer'): UserCriteria {
    switch (type) {
      case 'seeker':
        return {
          Seeker: {
            Keyword: params.q,
            State: params.state, City: params.city,
            Promoted: params.vanguard, IsOpenToWork: params.openToWork,
            LastUpdateFrom: params.update ? new Date(Date.now() + (-params.update * 1000 * 60 * 60 * 24)) : undefined,
            IsEmployed: params.unemployed ? false : undefined,
            Gender: params.g,
            MinAge: params.minAge, MaxAge: params.maxAge,
            Agreements: [params.karpashaReg].filter(_ => _),
            JobAlert: { JobTypes: params.jt ? [params.jt] : undefined },
            KarpashaProgress: {
              GuideId: params.guide || undefined,
              KarpashaId: params.karpasha || undefined,
              IsPaid: params.karpashaPaid || undefined
            },
            RecruitLead: params.recruitLead ? { Statuses: [+(params.recruitLead)] } : undefined,
          },
          Sort: params.sort || null
        };
      case 'employer':
        return {
          Employer: {
            Keyword: params.q,
            State: params.state, City: params.city,
            Agreements: params.karbaladAgreed ? [KarpashaAgreements.karbaladService] : undefined,
            IsPromoted: params.promoted ? true : undefined,
            Rank: params.rank !== undefined ? params.rank : undefined,
            KarpashaProgress: {
              KarpashaId: Guid.Empty
            }
          }
        };
    }

  }
}
export class ActivityCriteria {
  Keyword?: string;
  CreatorId?: string;
  OperatorId?: string;
  UserId?: string;
  JobId?: string;
	ReadyToWorkAdId?: string;
  FromDate?: Date;
  ToDate?: Date;
  IsDone?: boolean;
  Type?: ActivityType;
  IncludeUserSummary?: boolean;
}
export enum ActivityType {
  unknown = -1,
  note = 0,
  task = 1,
  verify_ads = 3,
  control_report = 4,
  employer_nps = 5,
  prepare_tasks = 6,
  vanguard_seeker = 7,
  push = 8,
  sms = 9,
  email = 10,
  reportage = 11,
  telegram_group = 12,
  instagram_post = 13,
  telegram_post = 14,
  instagram_story = 15,
  linkedin = 16,
  twitter = 17,
  buy_resume = 18,
}
export enum OrganizationStatus {
  Unknown = -1,
  Active = 0,
  Pending = 1,
  Rejected = 2,
}
export class UserSearchResult {
  users: any[];
  total: number;
}
export enum UserSortType {
  RegisterTime = 1,
  Score = 2,
  UpdateTime = 3,

  ResumeUpdateTime = 4,
  PromoteUntil = 5,
  AgentUpdateTime = 6,
  EmployerUpdateTime = 7,

  RandomScore = 8,
  AlertMatching = 9
}
export class DocumentCriteria {
  Keyword?: string;
  IsDisabled = false;
}
export class ContentCriteria {
  Keyword?: string;
  Statuses?: ContentStatus[];
  Tags?: string[];
}
export enum ContentStatus {
  None = -1,
  Draft = 0,
  Pending = 1,
  Published = 2,
  Archived = 3
}
export enum KarpashaDataStatus {
  InProgress = 0,
  Rejected = 1,
  Completed = 2
}
